<template>
  <editor :id="id" default-tab="list_data_multi_upload" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Basic from './list_data/MultiUpload'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Upload files", name: "list_data_multi_upload", component: Basic},
      ]
    }
  }
}
</script>
